import { makeStyles } from "@material-ui/core";

const tableStyles = makeStyles({
  cabecalho: {
    fontSize: 16,
    fontWeight: 500,
    color: "#5e6784",
  },
  body: {
    fontSize: 16,
    lineHeight: 1.38,
    color: "#061243",
  },
  bodyDetalhe: {
    fontSize: "12px",
    color: "#5e6784",
  },
  bodyNome: {
    textTransform: "capitalize",
  },
  bodyCriadoPor: {
    fontStyle: "italic",
  },
  bodyDataCriado: {},
  bodyDataEditado: {
    fontStyle: "italic",
  },
  gridHover: {
    "&:hover": {
      backgroundColor: "#d5d5d5",
    },
  },
});

export default tableStyles;
